<div *ngIf="show" 
     [class]="'innovative-logo-loader ' + (overlay ? 'loadingOverlay' : '') + ' ' + customClass" 
     [class.size-small]="size === 'small'" 
     [class.size-medium]="size === 'medium'" 
     [class.size-large]="size === 'large'">
   
  <div class="typing-container">
    <p-progressSpinner [style]="{height: '1.875rem', width: '1.875rem'}" strokeWidth="7" animationDuration="0.5s">
    </p-progressSpinner>
  </div>
</div>